<template current-page="TrackingsIndex">
  <router-view></router-view>
</template>

<script>
export default {
  name: "TrackingsIndex",
};
</script>
